/**
 * EazeApps uses wa.me for every device. Mobile browsers correctly hand that
 * URL to the WhatsApp app, but some desktop browsers fail at its intermediate
 * api.whatsapp.com page. Send desktop clicks directly to WhatsApp Web while
 * leaving the app's mobile link and presentation untouched.
 */
(() => {
  const isMobileDevice = () => {
    if (typeof navigator.userAgentData?.mobile === 'boolean') return navigator.userAgentData.mobile;

    return /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  if (isMobileDevice()) return;

  document.addEventListener(
    'click',
    (event) => {
      const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const isEazeAppsButton = eventPath.some(
        (element) => element instanceof HTMLElement && element.localName === 'gty-whatsapp-chat-button'
      );

      if (!isEazeAppsButton) return;

      const link = eventPath.find(
        (element) => element instanceof HTMLAnchorElement && element.hostname === 'wa.me'
      );

      if (!link) return;

      const phoneNumber = link.pathname.replace(/\D/g, '');
      if (!phoneNumber) return;

      const desktopUrl = new URL('https://web.whatsapp.com/send');
      desktopUrl.searchParams.set('phone', phoneNumber);

      const message = new URL(link.href).searchParams.get('text');
      if (message) desktopUrl.searchParams.set('text', message);

      event.preventDefault();
      event.stopImmediatePropagation();
      window.open(desktopUrl.toString(), '_blank', 'noopener,noreferrer');
    },
    true
  );
})();
